import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import withModal from "../withModal";
import { hideModal } from "../../../actions/actionCreators";
import { getCompaniesForUser } from "../../../reducers/userCompanies";
import MaterialModal from "../MaterialModal";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";

const UserCompaniesModal = ({ isOpen, modalProps }) => {
    const dispatch = useDispatch();

    const userCompanies = useSelector(state => getCompaniesForUser(state, modalProps) || []);

    const hide = () => dispatch(hideModal("USER_COMPANIES"));

    const renderCompany = company => (
        <div key={company.CompanyID}>
            <ListItem>{company.CompanyName}</ListItem>
            <Divider />
        </div>
    );

    const renderUserCompanies = () => {
        const content = userCompanies.map(c => renderCompany(c));

        return <List aria-label="user-companies-list">{content}</List>;
    };

    return (
        <MaterialModal
            id="user-companies-modal"
            isOpen={isOpen}
            onClose={hide}
            title="User Companies"
            showPrimaryButton={false}
            cancelButtonText="Close"
        >
            {renderUserCompanies()}
        </MaterialModal>
    );
};

UserCompaniesModal.propTypes = {
    modalProps: PropTypes.object,
    isOpen: PropTypes.bool,
    userCompanies: PropTypes.array,
    // Injected from Redux (ActionCreators)
    hideModal: PropTypes.func,
};

export default withModal(UserCompaniesModal, "USER_COMPANIES");
